import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import React from "react";
import { useBranchCourseContext } from "../BranchCourseDataContext";
import { BranchCampFeeEditTableRow } from "./BranchCampFeeEditTableRow";
import {
  getCourseCampInd,
  getLegacyTableType,
  SCHOOL_CAMP_IND,
} from "./feeCourseKind";

export const BranchCampFeeEditTable = ({
  values,
  errors,
  touched,
  deleted,
  setDeleted,
}) => {
  const DROPDOWN_TYPE = useBranchCourseContext().TYPES;
  // Show the batch-type sections that match the course's own camp_ind, so a
  // school course (camp_ind 2) gets its "School Program" section. Works with
  // no fee rows: every section still renders with its add-row button.
  const courseCampInd = getCourseCampInd(values, DROPDOWN_TYPE.BATCH_TYPE);
  const TYPE = getLegacyTableType(courseCampInd);
  return (
    <span>
      <Table>
        <TableBody>
          {DROPDOWN_TYPE.BATCH_TYPE.filter((bt) => {
            return bt.camp_ind == courseCampInd;
          }).map((bt) => {
            return (
              <BranchCampFeeEditTableRow
                key={bt.id}
                values={values}
                errors={errors}
                touched={touched}
                deleted={deleted}
                setDeleted={setDeleted}
                bt={bt}
                TYPE={TYPE}
                isSchool={courseCampInd === SCHOOL_CAMP_IND}
              />
            );
          })}
        </TableBody>
      </Table>
    </span>
  );
};
